import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import WhyXpertpests from './pages/WhyXpertpests';
import FeaturesPage from './pages/FeaturesPage';
import Pricing from './pages/Pricing';
import Resources from './pages/Resources';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TechApp from './pages/TechApp';
import CustomerPortal from './pages/CustomerPortal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SmsPolicy from './pages/SmsPolicy';
import BookService from './pages/BookService';
import Terms from './pages/Terms';
import FeatureGraphic from './pages/FeatureGraphic';
import PaymentReturn from './pages/PaymentReturn';
import PayInvoice from './pages/PayInvoice';
import SignDocument from './pages/SignDocument';
import { ConfigProvider } from './context/ConfigContext';
import { LanguageProvider } from './lib/i18n';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <ConfigProvider>
      <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-xpertpests" element={<WhyXpertpests />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/customers" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app/*" element={<Dashboard />} />
          <Route path="/tech/*" element={<TechApp />} />
          <Route path="/portal/*" element={<CustomerPortal />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/sms-policy" element={<SmsPolicy />} />
          <Route path="/sms-terms" element={<SmsPolicy />} />
          <Route path="/book" element={<BookService />} />
          <Route path="/request-service" element={<BookService />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/play-assets" element={<FeatureGraphic />} />
          <Route path="/payment-return" element={<PaymentReturn />} />
          <Route path="/pay/:invoiceId" element={<PayInvoice />} />
          <Route path="/sign/:id" element={<SignDocument />} />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
      </ConfigProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
